import { createSlice } from '@reduxjs/toolkit';

const confirmSlice = createSlice({
  name: 'confirm',
  initialState: {
    isShow: false,
    title: '',
    message: [],
    callback: () => {},
  },
  reducers: {
    open: (state, { payload: { message, title, callback } }) => {
      state.isShow = true;
      state.message = message;
      state.title = title;
      state.callback = callback || (() => {});
    },
    close: state => {
      state.isShow = false;
    },
  },
});

export const { open, close } = confirmSlice.actions;
export default confirmSlice.reducer;
